import './mobileNav.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { RoleIds } from '../../../models';

function MobileNav({ isProClient }) {
    return (
        <div className="mobile-nav">
            <NavLink activeClassName="active" to="/profile">
                <div>My Profile</div>
            </NavLink>
            <NavLink activeClassName="active" to="/orders">
                <div>My Orders</div>
            </NavLink>
            <NavLink
                activeClassName="active"
                to={isProClient ? '/inventory' : '/proClientAccessInformation'}
            >
                <div>Taxidermy STARS</div>
            </NavLink>
        </div>
    );
}

MobileNav.propTypes = {
    isProClient: PropTypes.bool,
};

MobileNav.defaultProps = {
    isProClient: false,
};

const mapStateToProps = ({
    authentication: {
        user: { roleId },
    },
}) => {
    const isProClient = roleId === RoleIds.PROCLIENT;
    return {
        isProClient,
    };
};

export default connect(mapStateToProps)(MobileNav);
